import { Dashboard } from 'common/pages/dashboard/Dashboard.tsx'

export const DashboardFormAgency = (props: any) => <Dashboard {...props} mode={props.mode} agency />
